export default "__VITE_ASSET__GOi5KeNm__"